(function($, Drupal, drupalSettings) {

  Drupal.behaviors.mbo_hero_001 = {
    attach: function (context, settings) {

        // Check to add hybrid class to page dive.
        if ($('.paragraph--type--mbo-hero-001.mbo-hero-001--header-hybrid').length) {
            $('#page').addClass('mbo_hero_001--mbo_nav_001--header-hybrid');
        }

        // Check to make sections full screen height.
        $('.paragraph--type--mbo-hero-001.mbo-hero-001--screen-height').each(function(index, value){
            $(value).closest('.layout--mbf-col-section').addClass('mbo_hero_001--mbo_nav_001--screen-height');
        });

        // Call MBO Nav 001 function again to set the header and spacer sizes.
        Drupal.behaviors.mbo_nav_001.fixedHeaderSpace();

        // Mute and autoplay video, also sort sie to fill hero.
        function mbfHeroVideoSize() {
          $('.paragraph--type--mbo-hero-001').each(function(index, value){
            // Reset video width.
            $('.video-inline', value).css('width', '100%');

            // Get all sizes.
            var heroHeight = $('.video-inline', value).outerHeight();
            var heroWidth =  $('.video-inline', value).outerWidth();
            var videoHeight = $('.video-inline video', value).outerHeight();

            console.log(videoHeight, heroHeight);


            // Increase container width for video to fill hero.
            if (videoHeight < heroHeight) {
              var requiredWidth =  heroWidth;
              while (heroHeight > (requiredWidth * 0.5625)) {
                requiredWidth += 5;
              }

              $('.video-inline', value).css('width', requiredWidth + 'px');
            }
          });
        }

        function mbfHero001VideoStart(hero) {
          if (!$('iframe', hero).length && !$('video', hero).length) {
            $('.paragraph-type-mba-media-002 .field-name-video-thumbnail-image', hero).trigger('click');
            mbfHeroVideoSize();
          }
        }
        $('.paragraph--type--mbo-hero-001').each(function(index, value){
          if ($('.paragraph--type--mbo-hero-001 .field-name-video-thumbnail-image').length) {
            mbfHero001VideoStart(value);

            $(window).once('mbf-hero-001-video-size').resize(function() {
              mbfHeroVideoSize();
            });
          }
        });




    }
  }; // Drupal.behaviors.mbo_hero_001

})(jQuery, Drupal, drupalSettings);
